import api from "Common/Client/Interceptor";

export const categoryService = {
  // Get all categories with sub-categories
 getCategoriesWithDetails: async ({
    pageNumber = 1,
    pageSize = 10,
    orderByLatest = true,
    onlyWithSubCategories = false
  } = {}) => {
    try {
      const response = await api.get(
        "/indv/CourseCategory/list-with-details",
        {
          params: {
            PageNumber: pageNumber,
            PageSize: pageSize,
            OrderByLatest: orderByLatest,
            onlyWithSubCategories
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching categories with details:", error);
      throw error;
    }
  },

  // Get category details for update (with isUsed flags)
  getCategoryForUpdate: async (categoryId) => {
    try {
      const response = await api.get(`/indv/CourseCategory/get-for-update/${categoryId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching category for update:", error);
      throw error;
    }
  },

  // Update sub-categories
  updateSubCategories: async (categoryId, subCategoriesData) => {
    try {
      const response = await api.put(`/indv/CourseCategory/update-subcategories/${categoryId}`, subCategoriesData);
      return response.data;
    } catch (error) {
      console.error("Error updating sub-categories:", error);
      throw error;
    }
  },

  // Add main category
  addCategory: async (categoryData) => {
    try {
      const response = await api.post("/indv/CourseCategory/main-category/create", categoryData);
      return response.data;
    } catch (error) {
      console.error("Error adding category:", error);
      throw error;
    }
  },

  // Edit category
  editCategory: async (id, categoryData) => {
    try {
      const response = await api.put(`/indv/CourseCategory/edit/${id}`, categoryData);
      return response.data;
    } catch (error) {
      console.error("Error editing category:", error);
      throw error;
    }
  },

  // Add sub-categories
  addSubCategories: async (data) => {
    try {
      console.log(data);
      const response = await api.post("/indv/CourseCategory/sub-category/create-list", data);
      return response.data;
    } catch (error) {
      console.error("Error adding sub-categories:", error);
      throw error;
    }
  },

  // Delete sub-category
  deleteSubCategory: async (subCategoryId) => {
    try {
      const response = await api.delete(`/indv/CourseCategory/sub-category/${subCategoryId}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting sub-category:", error);
      throw error;
    }
  },

  // Delete category
  deleteCategory: async (id) => {
    try {
      const response = await api.delete(`/indv/CourseCategory/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting category:", error);
      throw error;
    }
  }
};